export default "__VITE_ASSET__BNFMkhPj__"